<template>
  <el-dialog
    title="强制阅读"
    :visible="visi"
    width="35%"
    :close-on-click-modal="false"
    @close="closePup"
  >
    <el-form :model="formInItem" style="margin-top:20px">
      <el-form-item label="">
          <el-checkbox v-model="formInItem.needRead"
          >需阅读
          <span @click.stop.prevent>
            <el-input-number
              v-model="formInItem.readTime"
              size="mini"
              :min="5"
              :max="300"
            ></el-input-number>
          </span>
          秒并阅读至合同末尾</el-checkbox
        >
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="closePup">取 消</el-button>
      <el-button type="primary" size="small" @click="setConfirm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>

export default {
  props: {
    visi: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      formInItem: {
        needRead: true,
        readTime: 5
      },
    };
  },
  methods: {
    closePup() {
      this.formInItem= {
        needRead: true,
        readTime: 5
      },
      this.$emit("PupConfirm", false);
    },
    setConfirm() {
      this.$emit("PupConfirm", this.formInItem);
    },
  },
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// pages/initiation/components/readPup.vue